module.exports = __webpack_public_path__ + "media/images/mailer/icon_cached-9362919622b8a8396fab8fd5ac28d6eb.png";